import React from "react";
import ContactUsMain from "../components/About/Mainhead";
import WhoWeAre from "../components/About/whoweare";
import VissionandMission from "../components/About/VissionMission";
import WhyChooseUs from "./About/WhyChooseUsSection";
import image1 from "../components/asstes/leader vision our.jpg"
const About = () => {
  return (
    <div >
      <ContactUsMain />
      <WhoWeAre />
      <div>
        <div
          style={{
            width: "100%",
            // Optional: Limit the width
            marginBottom: "40px",
            overflow: "hidden", // Optional: Prevent image overflow
            borderRadius: "8px", // Optional: Rounded corners for the image container
          }}
        >
          <img
            src={image1}
            alt="Real Estate"
            style={{
              width: "100%",
              height: "auto", // Maintain aspect ratio
              borderRadius: "8px", // Optional: Rounded corners for the image itself
            }}
          />
        </div>

      </div>
      <VissionandMission/>
       <WhyChooseUs/>
    </div>
  );
};

export default About;
